export const REDIRECT_REPORT_TO_DNA_REPORT_TABS: false | true = true;
